// extracted by mini-css-extract-plugin
export default {"details":"J1q6dptnOxcWWN0PD3DJ","header":"fKDmQQH9IFnxNv8STelF","title":"obR95oYwd1xJ7IDq3PcA"};